import { Route } from 'react-router-dom';
import BookingConfirmationPage from '../pages/guest/BookingConfirmationPage';
import BookingDetails from '../pages/guest/BookingDetails';
import GuestBooking from '../pages/guest/GuestBooking';
import IdVerificationPage from '../pages/guest/IdVerificationPage';
import MyStayPage from '../pages/guest/MyStayPage';
import PaymentDetailsPage from '../pages/guest/PaymentDetailsPage';

export const GuestRoutes = [
  <Route key="booking" path="/booking" element={<GuestBooking />} />,
  <Route key="booking-details" path="/booking-details" element={<BookingDetails />} />,
  <Route key="payment-details" path="/payment-details" element={<PaymentDetailsPage />} />,
  <Route key="booking-confirmation" path="/booking-confirmation" element={<BookingConfirmationPage />} />,
  <Route key="verify-identity" path="/verify-identity" element={<IdVerificationPage />} />,
  <Route key="my-stays" path="/my-stays" element={<MyStayPage />} />,
]; 